/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
import { forwardRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { FONT_SCALE } from "../../constants/flyer";

// The flyer design from pages/flyers/new.jsx, as a component of its own so
// /start can render it without the flyer editor (that page stays untouched;
// keep the two in step). Width-relative throughout, so the same markup renders
// the on-screen preview and the PDF at any paper size. Keeps the
// .preview-content class: App.css styles the description's rich text through it.
const FlyerRender = forwardRef(function FlyerRender(
  { logoUrl, headerText, formUrl, descriptionHtml, backgroundColor, textColor, showFooter, fontSize, className = "", style },
  ref,
) {
  return (
    <div
      ref={ref}
      translate="no"
      className={`preview-content overflow-hidden flex flex-col items-center pt-[5%] pb-[7%] ${className}`}
      style={{ backgroundColor, fontSize: fontSize ?? `${FONT_SCALE * 100}cqw`, lineHeight: 1.15, ...style }}
    >
      {logoUrl && <img src={logoUrl} alt="" className="w-[40%] h-auto object-contain shrink-0" />}
      <div className="shrink grow-0 basis-[2.6em] min-h-0" />
      <div className="w-full shrink-0 text-center text-[1.5em] font-bold" style={{ color: textColor, lineHeight: "1.25em" }}>
        {headerText}
      </div>
      <div className="shrink grow-0 basis-[1.3em] min-h-0" />
      <div className="w-[40%] shrink-0">
        <QRCodeSVG style={{ width: "100%", height: "100%" }} value={formUrl} level="H" margin={2} includeMargin={true} />
      </div>
      <div className="shrink grow-0 basis-[2.25em] min-h-0" />
      <div className="w-full shrink-0" style={{ color: textColor, lineHeight: 1.3 }}>
        <div className="text-[0.875em]" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
      </div>
      <div className="flex-1 min-h-0" />
      {showFooter && (
        <div className="w-full shrink-0 text-center text-[0.75em]" style={{ color: textColor }}>
          Powered by Loyaltify.io
        </div>
      )}
    </div>
  );
});

export default FlyerRender;
